import React from 'react'
import styled from 'styled-components'
import Add from 'react-icons/lib/md/add'
import Filter from 'react-icons/lib/md/filter-list'

import Button from './Button'

const Wrapper = styled.div`
  padding: ${props => props.theme.space[2]}px 0;
  display: flex;
  justify-content: space-between;
`

const Actions = ({onCreate, onFilter}) => {
  return (
    <Wrapper>
      <div>
        <Button circle onClick={onFilter} secondary><Filter/>&nbsp;Filter</Button>
      </div>
      <Button circle onClick={onCreate}><Add />&nbsp;Create</Button>
    </Wrapper>
  )
}

export default Actions


// WEBPACK FOOTER //
// ./src/components/Actions.js